<script setup lang="ts">
import {
  StoreRestaurantAreas,
  RestaurantAreaType,
  RestaurantAreas,
  MismatchingStateType,
  MismatchingState,
} from '~/lib/interfaces/restaurant'
import { ProductEcommerce } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  product: ProductEcommerce
  notMatchingStatus?: MismatchingStateType
  area: RestaurantAreaType
}>()

const { t } = useLocale()

const isOutOfDayPart = computed(() => !props.product.active)

const notMatchingStatusText = computed(() => {
  if (!props.notMatchingStatus) return undefined
  const isMismatchingArea = props.notMatchingStatus === MismatchingState.MISMATCHING_AREA
  const key = !isMismatchingArea
    ? props.notMatchingStatus
    : `${props.notMatchingStatus}.${props.area}`
  return t(`productDetail.alerts.mismatching.${key}`)
})

const text = computed(() => {
  if (isOutOfDayPart.value) return t('productDetail.alerts.outdaypart')
  if (props.area !== RestaurantAreas.MOP) return undefined
  // check areas on pickup
  const missingAreas: string[] = []
  for (const key in StoreRestaurantAreas) {
    if (key !== 'DLV') {
      if (!props.product.areas.includes(key))
        missingAreas.push(t(`common.areas.${key.toLowerCase()}`))
    }
  }
  if (!missingAreas.length) return undefined
  const multipleAreas = missingAreas.length > 1
  const areasString = transformArrayToString(missingAreas, ',', t('common.and'))
  return t(`productDetail.alerts.notAvailableAreas.title${multipleAreas ? 'Multiple' : ''}`, {
    value: areasString,
  })
})
</script>

<template>
  <div class="md:pt-4">
    <section v-if="product.mcDia">
      <LazyProductAlertMcDia :product="product" />
    </section>
    <section v-if="notMatchingStatus || text" class="md:my-8">
      <ProductAlert v-if="notMatchingStatus" :text="notMatchingStatusText" />
      <ProductAlert v-if="text" :text="text" />
    </section>
  </div>
</template>
